export default {
    common: {
      loading: '加载中...',
      noData: '暂无产品数据。',
    },
    nav: {
      home: '首页',
      products: '产品',
      solutions: '解决方案',
      about: '关于我们',
      partnership: '合作伙伴',
      blog: '博客',
    },
    home: {
      text: '首页',
      title: '禹行创新',
      hero: {
        title1: 'Empowering Global Partners',
        title2: 'Securing the Future from Above',
        bookDemo: '预约演示',
      },
    },
    overview: {
      title: '概览',
      subtitle: 'YOOX S3T 无人机平台',
      content: 'YOOX S3T 是一款先进的无人机（UAV），能够搭载重型载荷、稳定飞行并灵活机动。它被设计为当今市场上最优秀的自主飞行无人机之一，具有超长飞行时间和出色的远距离性能，可广泛应用于军事行动、工业任务和人道主义援助任务。',
      content2: '我们不仅销售无人机，也致力于帮助您的无人机品牌在本地取得成功。我们提供本地化生产与组装解决方案，帮助您在当地建立自己的生产体系，自主制造最适合本地市场的无人机。',
    },
    scenarios: {
      title: '应用场景',
      subtitle: '后续可扩展更多行业场景',
    },
    advantages: {
      title: '核心优势',
      subtitle: '可根据需求持续丰富与细化',
    },
    products: {
      title: '产品中心',
      intro: '产品介绍',
      subtitle: '行业级飞行平台及生态产品',
      gallery: {
        all: '全部',
      },
      contact_business: '请联系我们了解该产品详情',
      tab: {
        introduce: '产品介绍',
        specs: '技术规格',
        faqs: '常见问题',
        videos: '视频',
      },
    },
    solutions: {
      title: '解决方案',
      intro: '方案介绍',
      subtitle: '行业解决方案与交付能力',
      gallery: {
        all: '全部',
      },
      contact_business: '请联系我们了解该方案详情',
      noData: '暂无方案数据。',
    },

    about: {
      text: '关于我们',
      title: '关于我们',
      teamTitle: '我们的团队',
      teamSubtitle: '来自全球领先科技公司',
      teamContent: '我们的核心团队来自 DJI、Yamaha、Apple、Tesla 等全球领先企业，平均拥有十年以上无人机行业经验，并在安防与防务场景具备深厚的产品与工程积累。',
      visionTitle: '我们的愿景',
      visionSubtitle: '帮助你的无人机品牌在本地成功',
      visionContent: '我们不仅提供高性能无人机产品，也提供本地化生产与组装方案，帮助合作伙伴建立可持续的本地制造体系，打造更适配本地市场需求的无人机能力。',
    },
    partnership: {
      title: '合作',
      primaryCta: '批发 & ODM & OEM',
      secondaryCta: '成为经销商',
      qaTitle: '常见问题',
    },
    blog: {
      title: '博客',
      heading: '行业洞察与品牌动态',
      subheading: '关于无人机技术、本地化制造与市场趋势的最新内容。',
      searchPlaceholder: '搜索文章',
    },
    contact: {
      title: '联系我们',
      title2: '欢迎与我们取得联系。',
      content1: '如需了解更多信息或合作机会，请通过 WhatsApp、Telegram 或表单联系我们。',
      whatsappLabel: 'WhatsApp',
      whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
      telegramLabel: 'Telegram',
      telegramValue: 'Telegram: <YOUR_TELEGRAM>',
      form: {
        title: '联系表单',
        subtitle: '欢迎与我们取得联系。',
        firstName: '名字',
        lastName: '姓氏',
        email: '邮箱',
        phone: '电话',
        company: '公司',
        country: '国家/地区',
        interestLabel: '你感兴趣的内容',
        interests: ['产品购买', '成为经销商', 'OEM/ODM 合作', '技术咨询', '其他'],
        message: '需求与说明',
        submit: '提交',
        submitTip: '感谢你的咨询，我们会尽快与你联系。',
        submitError: '提交失败，请稍后重试。',
      },
    },
    notFound: {
      exclamation: '哎呀！',
      message: '看起来这个页面不存在',
      cta: '带我离开这里',
      metaTitle: '糟糕，页面未找到',
    },
    related: {
      title: '相关',
    },
}
